import { useQuery } from '@connectrpc/connect-query';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { LoaderDot } from '@thetreep/travel-ui';

import { missionStepTarget } from '@/domains/mission/utils/missionStepTarget';
import { getMissionNavigationState } from '@/gen/view/v1/view-ViewService_connectquery';

export const Route = createFileRoute('/$missionId/')({
	component: MissionEntryRoute,
});

function MissionEntryRoute() {
	const { missionId } = Route.useParams();
	const { data, error } = useQuery(
		getMissionNavigationState,
		{ missionId },
		{ refetchOnMount: 'always' },
	);

	if (error) {
		throw error;
	}
	if (!data) {
		return <LoaderDot className="mt-24 w-full justify-center" />;
	}

	return <Navigate {...missionStepTarget(missionId, data)} replace />;
}
